/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiMediaCSVHeaderFieldFromJSON(json) {
    return ApiMediaCSVHeaderFieldFromJSONTyped(json, false);
}
export function ApiMediaCSVHeaderFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fields': !exists(json, 'fields') ? undefined : json['fields'],
        'raw': !exists(json, 'raw') ? undefined : json['raw'],
    };
}
export function ApiMediaCSVHeaderFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fields': value.fields,
        'raw': value.raw,
    };
}
